import { useField } from 'formik';
import React from 'react';

import TimeZoneAutocomplete from '@sophocles/components/TimeZoneAutocomplete';

// Formik-bound wrapper around the shared TimeZoneAutocomplete.  The
// IANA tz string is stored directly as the field value.
export default function SettingsTimeZoneField({ name, label, hiddenLabel = false, showCurrentTime = true }) {
  const [field, meta, helpers] = useField(name);
  const showError = Boolean(meta.touched && meta.error);
  return (
    <TimeZoneAutocomplete
      value={field.value || ''}
      onChange={value => helpers.setValue(value)}
      label={label}
      hiddenLabel={hiddenLabel}
      variant="filled"
      error={showError}
      helperText={showError ? meta.error : ''}
      showCurrentTime={showCurrentTime}
    />
  );
}
